import productList from '../utils/products'
import styles from './DashDetail.module.scss'
import { useLocation } from 'react-router-dom'
import { getLangName as t } from '../utils/index'

function DashboardDetail() {
  const { pathname } = useLocation();
  const dashKey = pathname.split('/')[2];
  let product = productList.find(item => item.key === dashKey);
  if (!product) {
    return <div>404</div>;
  }
  console.log("product", product)
  return <div className={styles.dashDetail}>
    <div className={styles.dashDetail_title}>{product.title}</div>
    <div className={styles.dashDetail_img}>
      <img src={product.img} />
    </div>
    <div className={styles.dashDetail_h1}></div>
    <div className={styles.dashDetail_name}>{t("ProductIntroduction")}</div>
    <div className={styles.dashDetail_imgDetail}>
      <img src={product.detailImg} />
    </div>
    <div className={styles.dashDetail_details}>
      {(product?.detail|| []).map((item, index) => <div className={styles.dashDetail_details_item} style={{
        flexDirection: index % 2 === 0 ? 'row' : 'row-reverse', // 奇数行从左到右，偶数行从右到左
      }}>
        <img src={item.img} />
        <div>
          <div className={styles.dashDetail_details_item_title}>{item.title}</div>
          <div className={styles.dashDetail_details_item_content}>
            {item?.content?.map(contentItem => <div>{contentItem}</div>)}
          </div>
        </div>
      </div>)}
    </div>
    {product.detailBox && <div className={styles.dashDetail_detailbox}>
      <div className={styles.dashDetail_detailbox_bg}>
        {product.detailBox?.label}
      </div>
      <div className={styles.dashDetail_detailbox_s}>
        {(product?.detailBox?.imgs || []).map((itemSD, index) => <div className={styles.dashDetail_detailbox_s_item} key={index}>
          <div className={styles.dashDetail_detailbox_s_item_title}>
            <img src={itemSD.img} />
            <span>{itemSD.title}</span>
          </div>
        </div>)}
      </div>
    </div>}
  </div>;
}

export default DashboardDetail;